import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import TextField from "@mui/material/TextField";

interface DuplicateTemplateModalProps {
  show: boolean;
  handleClose: () => void;
  templateName: string;
  modalTitle?: string;
  method: (workflowTemplateName: string) => void;
}
const DuplicateTemplateModal = ({
  show,
  handleClose,
  templateName,
  method,
  modalTitle,
}: DuplicateTemplateModalProps) => {
  const [workflowTemplateName, setWorkflowTemplateName] = useState<string>("Untitled");
  const inputRef = useRef<HTMLInputElement>(null);
  const handleWorkflowName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWorkflowTemplateName(event.target.value);
  };
  useEffect(() => {
    setWorkflowTemplateName(templateName);
  }, [templateName]);

  useEffect(() => {
    if (inputRef?.current) {
      inputRef?.current?.focus();
      inputRef?.current?.select();
    }
  }, []);
  return (
    <Modal className="DeleteModal" show={show} onHide={handleClose} centered>
      <Modal.Header className="clearConPopupHeader border-0">
        <Modal.Title>{modalTitle ? modalTitle : "Workflow template"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`DeleteModalBody border-0 rounded-bottom-4 px-4`}>
        <div className="w-100">
          <TextField
            id="outlined-helperText"
            label="Workflow name"
            inputRef={inputRef}
            value={workflowTemplateName}
            className="workflow-name-field"
            onChange={handleWorkflowName}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            sx={{
              width: "100%",
              borderRadius: "8px",
              "& .MuiOutlinedInput-root": {
                color: "var(--Main_icons_color)",
                caretColor: "var(--Main_icons_color)",
                "& fieldset": {
                  borderColor: "#12B6EA",
                },
                "&:hover fieldset": {
                  borderColor: "#12B6EA",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#12B6EA",
                  color: "var(--Main_icons_color)",
                  background: "transparent",
                  boxShadow: "none",
                  outline: "none",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "var(--Main_icons_color)",
                  opacity: 0.4,
                },
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "none !important", // Remove yellow background
                  WebkitTextFillColor: "var(--Main_icons_color) !important", // Autofill text color
                  transition: "background-color 5000s ease-in-out 0s",
                },
                "& input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active":
                  {
                    WebkitBoxShadow:
                      "0 0 0px 1000px transparent inset !important",
                    backgroundColor: "transparent !important",
                    WebkitTextFillColor: "var(--Main_icons_color)!important",
                    transition:
                      "background-color 5000s ease-in-out 0s !important",
                  },
              },
            }}
          />
        </div>
        <div className="line-sepeartor-cancelPopup mt-3 mb-3"></div>
        <div className="w-100 container-btns ">
          <div className="apply-buttons btns-create-workflow duplicate-workflow">
            <button className="CancelDeletePersonaBtn" onClick={handleClose}>
              Cancel
            </button>
            <button
              className={`NextCreateWorkflow ${
                workflowTemplateName.trim() === ""
                  ? ""
                  : "NextCreateWorkflowActive"
              }`}
              onClick={() => method(workflowTemplateName)}
              disabled={workflowTemplateName.trim() === ""}
              style={{ opacity: workflowTemplateName.trim() === "" ? 0.5 : 1 }}
            >
              Save
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DuplicateTemplateModal;
